import thaikitchen from './img/Thaikitchen1.jpg'
import jinseon from './img/jinseon.jpg'
import shin from './img/shin.jpg'
import chinared from './img/chinared.jpg'
import xiongqi from './img/xiongqi.png'
import lotusmoon from './img/lotusmoon.jpg'

import birm from './img/birm.jpg'
import castle from './img/castle.jpg'
import gokart from './img/gokart.jpg'
import karaoke from './img/karaoke.jpg'
import wwsport from './img/wwsport.jpg'

export const activities = [
    {
        name: 'China Red Karaoke',
        type: 'Karaoke',
        location: 'Coventry',
        description: '',
        img: karaoke
    },
    {
        name: 'TeamSport Go-Kart',
        type: 'Go-Kart',
        location: 'Near Uni',
        description: '',
        img: gokart
    },
    {
        name: 'Warwick Castle',
        type: 'Travel',
        location: 'Warwick',
        description: '',
        img: castle
    },
    {
        name: 'Birmingham',
        type: 'Shopping',
        location: 'Birmingham',
        description: '',
        img: birm
    },
    {
        name: 'Warwick Sport Centre',
        type: 'Sports',
        location: 'University',
        description: '',
        img: wwsport
    },
]

export const restaurants = [
    {
        name: 'Thai Kitchen',
        type: 'Thai Food',
        location: 'Kenilworth',
        description: '',
        img: thaikitchen
    },
    {
        name: 'Jinseon Korean BBQ',
        type: 'Korean BBQ',
        location: 'Coventry',
        description: '',
        img: jinseon
    },
    {
        name: 'Shin Ramen',
        type: 'Japanese Food',
        location: 'Coventry',
        description: '',
        img: shin
    },
    {
        name: 'China Red',
        type: 'Chinese Food',
        location: 'Coventry',
        description: '',
        img: chinared
    },
    {
        name: 'Xiong QI',
        type: 'Chinese Hotpot',
        location: 'Coventry',
        description: '',
        img: xiongqi
    },
    {
        name: 'Lotus Moon',
        type: 'Thai Food',
        location: 'Leamington Spa',
        description: '',
        img: lotusmoon
    }
]